<template>
  <div class="profile-actions">
    <img
      src="/avatar.png"
      alt="Аватар"
      class="profile-actions__avatar"
      @click="menuRef?.toggleMenuHandler"
    />
    <span class="profile-actions__name" @click="menuRef?.toggleMenuHandler">{{
      authStore.user?.name
    }}</span>
    <DropdownMenu ref="menu" :items="profileactionItems"
      ><SvgIcon icon="chevron-down" size="15" />
    </DropdownMenu>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import { useRouter } from 'vue-router'
import DropdownMenu from '@/components/UI/DropdownMenu.vue'
import { useApiCall } from '@/composables/useApiCall'
import { logoutApiCall } from '@/api/auth'
import { useAuthStore } from '@/stores/auth'
import type { DefaultError } from '@/types/api/httpError'

const router = useRouter()
const authStore = useAuthStore()

const profileactionItems = [
  {
    title: 'Выйти',
    color: 'red',
    callback: async () => {
      try {
        await logoutAction()
        authStore.clearStore()
        await router.push('/login')
      } catch {
        if (logoutError.value) {
          console.error(logoutError.value)
        }
      }
    },
  },
]

const menuRef = useTemplateRef<{ toggleMenuHandler: (event: MouseEvent) => void }>('menu')

const { executeApiCall: logoutAction, error: logoutError } = useApiCall<'', DefaultError>(
  logoutApiCall,
  true,
)
</script>

<style scoped lang="scss">
.profile-actions {
  display: flex;
  align-items: center;
  cursor: pointer;

  &__avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 4px;

    @include tablet {
      margin-right: 8px;
    }
  }

  &__name {
    @include textMedium(17px);
    white-space: nowrap;
  }
}
</style>
